/* Diagnóstico sanitizado da infraestrutura de scan exposto ao backoffice. Valores de
   configuração (URLs, secrets, workflow ref/SHA e audience) nunca atravessam este contrato. */
import { z } from 'zod';

export const scannerRuntimeModeDto = z.enum(['oidc', 'legacy_runner', 'unavailable']);
export type ScannerRuntimeMode = z.infer<typeof scannerRuntimeModeDto>;

export const scannerRuntimeActionDto = z.enum([
  'none',
  'configure_registry',
  'configure_runner',
  'check_runner',
  'check_registry',
]);
export type ScannerRuntimeAction = z.infer<typeof scannerRuntimeActionDto>;

export const manualScanAvailabilityDto = z.enum([
  'available',
  'oidc_managed',
  'registry_unavailable',
  'runner_unconfigured',
  'runner_unreachable',
]);
export type ManualScanAvailability = z.infer<typeof manualScanAvailabilityDto>;

export const centralScanBindingDto = z.enum([
  'ANALYTICS_DB',
  'REGISTRY_INTERNAL_URL',
  'PACK_SCAN_OIDC_AUDIENCE',
  'PACK_SCAN_CENTRAL_WORKFLOW_REF',
  'PACK_SCAN_CENTRAL_WORKFLOW_SHA',
  'PACK_SCAN_DISPATCH_REPOSITORY',
  'PACK_SCAN_DISPATCH_WORKFLOW',
  'PACK_SCAN_DISPATCH_REF',
  'PACK_SCAN_DISPATCH_SHA',
  'PACK_SCAN_GITHUB_TOKEN',
  'PACK_SCAN_CENTRAL_RELEASE_ENABLED',
  'PACK_SCAN_CENTRAL_CANARY_PUBLISHER_SLUGS',
]);
export type CentralScanBinding = z.infer<typeof centralScanBindingDto>;

export const scannerRuntimeStatusDto = z.object({
  mode: scannerRuntimeModeDto,
  ready: z.boolean(),
  oidc: z.object({
    configured: z.boolean(),
    ready: z.boolean(),
  }),
  centralScan: z.object({
    checked: z.boolean(),
    ready: z.boolean(),
    missing: z.array(centralScanBindingDto),
  }),
  legacyRunner: z.object({
    required: z.boolean(),
    adminConfigured: z.boolean(),
    registryConfigured: z.boolean(),
    reachable: z.boolean().nullable(),
  }),
  manualScan: z.object({
    available: z.boolean(),
    reason: manualScanAvailabilityDto,
  }),
  action: scannerRuntimeActionDto,
});
export type ScannerRuntimeStatus = z.infer<typeof scannerRuntimeStatusDto>;
